import Vue from 'vue';
import axios from 'axios';
import L, { control as lControl } from "leaflet";

export default {
  name: 'DebtManagementMap',
  components: {
    backButton: require('@/components/backButton/backButton.vue').default,
  },
  props: {
    parent: {
      type: Object
    },
    items: {
      type: Array,
      required: true
    },
    itemSelected: {
      type: Object,
      required: true
    },
    isBlueIcon: {
      type: Function,
      default: null,
    },
    isGreenIcon: {
      type: Function,
      default: null,
    },
    isRedIcon: {
      type: Function,
      default: null,
    }
  },
  data: function () {
    return {
      gisSettings: {},
      currentLocation: {
        lat: 0,
        lng: 0
      },
      selectedLocation: {
        lat: 0,
        lng: 0
      },
      mapSettings: {
        map: null,
        zoom: 18,
        center: [],
        isRendering: false
      },

      currLocIcon: null,
      currentLocMarker: null,
      currentLocCircle: null,
      showMap: true,
      showInfoTable: true,
    }
  },
  watch: {
    editReadingDataObj: function (val) {
      if (val)
        this.markCurrentReading();
    }
  },
  computed: {
    getInfoClass: function () {
      return this.showInfoTable ? "map-button-info-icon-on" : "map-button-info-icon-off";
    },
    hasSelectedLocation: function () {
      if (this.selectedLocation == null || (this.selectedLocation.lng == 0 && this.selectedLocation.lat == 0))
        return false;
      else
        return true;
    },
    hasCurrentLocation: function () {
      if (this.currentLocation == null || (this.currentLocation.lng == 0 && this.currentLocation.lat == 0))
        return false;
      else
        return true;
    },
  },
  mounted() {
    let temp = this.$localStorage.get('_map_info');
    this.showInfoTable = temp === 'false' ? false : true;
  },
  created() {
    this.$root.$on('update_selected_marker', this.drawConnectionsMarkers);

    navigator.geolocation.getCurrentPosition(this.getStartLocation, (err) => console.log(err));
  },
  methods: {
    showInfo() {
      this.showInfoTable = !this.showInfoTable;
      this.$localStorage.set('_map_info', this.showInfoTable);
    },
    getStartLocation(position) {
      this.currentLocation.lat = position.coords.latitude;
      this.currentLocation.lng = position.coords.longitude;

      this.currLocIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/currentLocationMarker.png'),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      this.mapSettings.center.push(position.coords.latitude, position.coords.longitude);
      this.getGisSettings();
    },
    getGisSettings() {
      axios.post('/gis/GetGisSettings')
        .then(response => {
          this.gisSettings = response.data;
          this.initMap();
        })
        .catch(error => {
          console.log(error);
        });
    },
    initMap() {
      this.mapSettings.map = L.map(this.$refs.map)
        .setView(this.mapSettings.center, this.mapSettings.zoom);

      let google = L.tileLayer('http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}',
        {
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
          attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          maxZoom: 21,
          minZoom: 11
        }
      );;

      let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          maxZoom: 21,
          minZoom: 11
        }
      );

      let googleEarth = L.tileLayer('https://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}',
        {
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
          attribution: '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          maxZoom: 21,
          minZoom: 11
        }
      );

      //default choice
      //osm.addTo(this.mapSettings.map);
      googleEarth.addTo(this.mapSettings.map); 

      //remove leaflet attribution
      this.mapSettings.map.attributionControl.setPrefix('');

      this.currentLocMarker = L.marker([this.currentLocation.lat, this.currentLocation.lng], {
        icon: this.currLocIcon,
        alt: 'CurrentLocation'
      }).addTo(this.mapSettings.map);

      //add all layers to map - overlayes not implemented
      (lControl.layers({
        OpenStreetMap: osm,
        "Google Map": google,
        "Google Earth": googleEarth,
      }) as any).addTo(this.mapSettings.map);

      setInterval(() => {
        navigator.geolocation.getCurrentPosition(this.getCurrentLocation);
      }, 5000);

      this.mapSettings.map.on('moveend', this.loadOnMove);
      this.drawConnectionsMarkers();
    },
    async drawConnectionsMarkers() {
      if (this.mapSettings.isRendering)
        return;

      this.mapSettings.isRendering = true;
      const bounds = this.mapSettings.map.getBounds();
      
      const displayItems = this.filterItemsByBounds(this.items, bounds); 
      
      this.clearReadingsMarkers();


      const blueIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-blue.svg'),//'https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png',
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const greenIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-green.svg'),//'https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png',
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      const redIcon = L.icon({
        iconUrl: require('@/assets/images/meterReadings/location-red.svg'),//'https://maps.gstatic.com/mapfiles/ms2/micons/red-dot.png',
        iconAnchor: [12, 41],
        popupAnchor: [12, -41]
      });

      while (this.mapSettings.isRendering) {
        for (let i = 0; i < displayItems.length; i++) {

          await this.sleep(1);
          let ic = greenIcon;

          //read/posted icon
          if (this.isBlueIcon) {
            ic = blueIcon;
          }

          //unread icon
          if (this.isGreenIcon) {
            ic = greenIcon;
          }

          //disconnected icon
          if (this.isRedIcon) {
            ic = redIcon;
          }
          
          const marker = L.marker([displayItems[i].gpsX, displayItems[i].gpsY], {
            icon: ic,
            alt: displayItems[i]
          }).addTo(this.mapSettings.map);

          marker.on('click', (event) => {
            //console.log(event.target.options.alt);
            this.$emit('selectedItemChanged', event.target.options.alt.sequence);
            this.markCurrentReading();
          });
        }
        
        this.mapSettings.isRendering = false;
      }

      this.markCurrentReading();
    },
    getCurrentLocation(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      if (lat == this.currentLocation.lat && lng == this.currentLocation.lng)
        return;

      this.currentLocation.lat = lat;
      this.currentLocation.lng = lng;

      this.mapSettings.map.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt == 'CurrentLocation')
            this.mapSettings.map.removeLayer(layer);
        }
      });

      L.marker([lat, lng], {
        icon: this.currLocIcon,
        alt: 'CurrentLocation'
      }).addTo(this.mapSettings.map);
    },
    filterItemsByBounds(items, bounds) {
      items = items.filter(item => item.gpsX && item.gpsY);

      return items.filter(item => {
        const mark = L.latLng(item.gpsX, item.gpsY);
        const readingBounds = L.latLngBounds(mark, mark);
        return bounds.intersects(readingBounds);
      });
    },
    loadOnMove() {
      this.mapSettings.isRendering = false;
      this.drawConnectionsMarkers();
    },
    markCurrentReading() {
      if (!this.itemSelected.sequence)
        return;

      this.mapSettings.map.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Marker && layer.options.alt !== 'CurrentLocation') {
          var icon = layer.options.icon;

          if (layer.options.alt['sequence'] == this.itemSelected.sequence) {
            icon.options.iconSize = [50, 50];
            icon.options.iconAnchor = [20, 50];
            icon.options.popupAnchor = [20, -50];

            this.selectedLocation = layer.getLatLng();
          }
          else {
            icon.options.iconSize = [32, 32];
            icon.options.iconAnchor = [16, 32];
            icon.options.popupAnchor = [16, -32];
          }

          layer.setIcon(icon);
        }
      });
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm)
      })
    },
    clearReadingsMarkers() {
      this.mapSettings.map.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt !== 'CurrentLocation') {
            this.mapSettings.map.removeLayer(layer);
          }
        }
      });
    },
    centerMap() {
      if (!this.haseSelectedLocation)
        this.markCurrentReading();

      //if no current or selected location return
      if (!this.hasSelectedLocation && !this.hasCurrentLocation)
        return;

      //if no select pan to current location
      if (!this.hasSelectedLocation && this.hasCurrentLocation) {
        this.mapSettings.map.setZoom(19).panTo(this.currentLocation);
        return;
      }

      //calulate midle point between two point
      let lat = 0, lng = 0;
      lng = (this.selectedLocation.lng + this.currentLocation.lng) / 2;
      lat = (this.selectedLocation.lat + this.currentLocation.lat) / 2;

      //center around point and zoom to have the both visible
      this.mapSettings.map.panTo(new L.LatLng(lat, lng))
        .fitBounds([this.selectedLocation, this.currentLocation]);
    },
  }
}
